import { combineReducers } from 'redux';

import { gradProgramsReducer as gradPrograms } from './gradPrograms';
import { integrationsReducer as integrations } from './integrations';
import { listingsReducer } from './listings';
import { orgsReducer as orgs } from './orgs';
import { searchReducer } from './search';

export const mainStoreOrgDashboardReducer = combineReducers({
  orgs,
  listings: listingsReducer,
  search: searchReducer,
  gradPrograms,
  integrations,
});
